var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LineChartGenerator',{staticStyle:{"height":"160px"},attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"chart-id":'lineChart'}})}
var staticRenderFns = []

export { render, staticRenderFns }